var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.696 42.825"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "streamline-icon-office-file-adobe@140x140",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.83
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 489",
    d: "M34.259 8.044a1.782 1.782 0 01.522 1.26v30.824a1.782 1.782 0 01-1.782 1.782h-30.3a1.782 1.782 0 01-1.782-1.782V2.698A1.782 1.782 0 012.699.916h23.692a1.782 1.782 0 011.26.519z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 490",
    d: "M7.798 12.303c-1.517-2.5 2.112-4.793 3.06-2.232 1.624 4.4 4.235 16.293-1.656 24.378-1.643 2.253-5.189.119-3.281-2.228a28.829 28.829 0 0122.212-10.186c2.973.112 2.82 4.335.16 4.01A27.756 27.756 0 017.798 12.303z"
  }))));
}

export default __webpack_public_path__ + "bbdca519d6aff556719946de812beaa2.svg";
export { SvgPdf as ReactComponent };